var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicTable',{ref:"data_table",attrs:{"id_tabla":10,"permission_new":[],"permission_update":[],"permission_delete":[]},on:{"edit":function($event){return _vm.editar($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }